import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideArrowRightLeft = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 3 4 4-4 4m4-4H4m4 14-4-4 4-4m-4 4h16"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideArrowRightLeft);
const Memo = memo(ForwardRef);
export default Memo;
